export default "__VITE_ASSET__BqXAAp_3__"